import { useParams } from 'react-router-dom'
import useTitle from '../../hooks/useTitle'
import { useState, useEffect } from 'react'
import ShowHepExercises from './showHepExercises'

import useAuth from "../../hooks/useAuth"
import { useEmailPlainMutation } from '../emails/emailsApiSlice'
import { toast } from 'react-toastify'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faEnvelope } from "@fortawesome/free-solid-svg-icons"
import { useNavigate } from "react-router-dom"


const ShowHep = () => {

    useTitle('DPE: Show HEP')

    const { hepid } = useParams()
    const { userId } = useAuth()
    const navigate = useNavigate()

    // server info
    let server_url
    if (process.env.NODE_ENV === 'production') {
        server_url = 'https://dpe-mern-server.onrender.com'
    } else {
        server_url = 'http://localhost:3500'
    }

    // hep info
    const [title, setTitle] = useState('')
    const [text, setText] = useState('')
    const [user, setUser] = useState('')

    // exercise info
    const [exercises, setExercises] = useState([])

    // provider info
    const [firstname, setFirstname] = useState('')
    const [lastname, setLastname] = useState('')
    const [clinic, setClinic] = useState('')
    const [phone, setPhone] = useState('')
    const [email, setEmail] = useState('')

    // email fields
    const [sendTo, setSendTo] = useState('')
    const [sendFrom, setSendFrom] = useState('')
    const [replyTo, setReplyTo] = useState('')
    const subjectText = 'Here is your home exercise program'
    
    // email message
    //let htmlText = "<p style='font-size: large'><a href='http://dpe.smidtmanagement.com'>Click here</a> for your home program: </p>"
    //htmlText= htmlText + "<p style='font-size: large'>and enter this code:<br/><span style ='background-color: blue; color: white; font-size: xx-large'>"
    //htmlText= htmlText + `${hepid}`
    //htmlText= htmlText + "</span></p>"
    let htmlText = `<p style='font-size: large'><a href='http://dpe.smidtmanagement.com/portal/`
    htmlText= htmlText + `${hepid}`
    htmlText =htmlText + `'>Click here</a> for your home program: </p>`
    htmlText =htmlText + `<p style='font-size: large'>Warmest regards,<br>` + `${firstname} ${lastname}` + `<br>`+ `${clinic}` + `</p>`

    // update email address
    const onSendToChanged = e => {
        setSendTo(e.target.value)

        // defaults
        setSendFrom(`${firstname} ${lastname} <webmaster@smidtmanagement.com>`)
        setReplyTo(email)
    }

    // Send email function
    const [sendEmail, { data }] = useEmailPlainMutation()

    useEffect(() => {
        if (data) {
            if (data.message) {
                toast.error(<>Email was NOT Send:<br />{data.message}</>);
            } else {
                toast.success("Email was Send");
                navigate('/dash/hep');
            }
        }

    }, [data, navigate]) // eslint-disable-line react-hooks/exhaustive-deps



    // check fields before sending email
    let canSave
    canSave = [sendTo, sendFrom, replyTo, subjectText, htmlText].every(Boolean)
    const onSendEmailClicked = async (e) => {
        e.preventDefault()

        if (canSave) {
            await sendEmail({ sendTo, sendFrom, replyTo, subjectText, htmlText })
        } else {
            toast.error('Can Not Send Email');
        }
    }


    useEffect(() => {

        fetchHep();
    }, []) // eslint-disable-line react-hooks/exhaustive-deps

    useEffect(() => {

        fetchUser();
    }, [user]) // eslint-disable-line react-hooks/exhaustive-deps

    useEffect(() => {

        fetchExercises();
    }, []) // eslint-disable-line react-hooks/exhaustive-deps


    const fetchHep = async () => {
        try {

            const fetchpath = server_url + `/portal/hep/${hepid}`

            const response = await fetch(fetchpath, {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                },
            });

            const data = await response.json()

            setTitle(data[0].title)
            setUser(data[0].user)
            setText(data[0].text)


        } catch (error) {
            console.error('Failed to fetch HEP:', error);
        }
    };

    const fetchUser = async () => {
        if (user !== '') {
            try {


                const fetchpath = server_url + `/portal/user/${user}`

                const response = await fetch(fetchpath, {
                    method: 'GET',
                    headers: {
                        'Content-Type': 'application/json',
                    },
                });

                const data = await response.json()

                setFirstname(data.firstname)
                setLastname(data.lastname)
                setClinic(data.clinic)
                setPhone(data.phone)
                setEmail(data.email)


            } catch (error) {
                console.error('Failed to fetch User:', error);
            }

        }
    };

    const fetchExercises = async () => {
        try {

            const fetchpath = server_url + `/portal/exercises/${hepid}`

            const response = await fetch(fetchpath, {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                },
            });

            const data = await response.json()
            setExercises(data)

        } catch (error) {
            console.error('Failed to fetch User:', error);
        }
    };




    const tableContent = exercises?.length && exercises.map(exercise => <ShowHepExercises
        key={exercise._id}
        description={exercise.description}
        name={exercise.exercise_id.exercise_name}
        details={exercise.exercise_id.exercise_details}
        video={exercise.exercise_id.video}

    />)

    let footerContent = null
    if (userId !== '') {
        // logged in: show option to email
        footerContent = (

            <>
            <hr/>
            <form onSubmit={e => e.preventDefault()}>
                <div className="row mt-3">
                    <div className="col-md-12">
                        <label className="form-label" htmlFor="sendTo">
                            Email To:
                        </label>
                        <input
                            className="form-control"
                            id="sendTo"
                            name="sendTo"
                            type="email"
                            autoComplete="off"
                            value={sendTo}
                            onChange={onSendToChanged}
                        />
                    </div>
                </div>
                <div className="row mb-3">
                    <div className="col-md-12">
                        <br />
                        <span
                            role="button"
                            className="p-2 text-info icon"
                            title="Send Email"
                            onClick={onSendEmailClicked}
                        >
                            Send Email
                            <FontAwesomeIcon icon={faEnvelope} className="fa-icon" />
                        </span>
                    </div>
                </div>

            </form>
            </>

        )
    }



    return (

        <section id="main_content" >
            <main id="print_content">
                <div className="row mt-3">
                    <div className="col-md-12 text-center text-steel">
                        <h6>
                            {firstname} {lastname} <br />
                            {(clinic) && <span>{clinic}</span>} <br />
                            {(email) && <span>{email}</span>} <br />
                            {(phone) && <span>{phone}</span>}
                        </h6>
                    </div>
                </div>

                <div className="row mt-3">
                    <div className="col-md-12 text-steel text-center"><h5>{title}</h5></div>
                </div>

                <div className="row">
                    <div className="col-md-12">
                        <h6 className="mt-3 text-steel">Instructions</h6>
                        <h6 style={{whiteSpace:"pre-wrap"}}>{text}</h6>
                        {tableContent}
                    </div>
                </div>
            </main>
            <footer>
                {footerContent}
            </footer>
        </section>


    )


}
export default ShowHep